import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';
import { CompanyService } from '../../services/company-service/company.service';


@Component({
  selector: 'company-location-select',
  templateUrl: './company-location-selector.component.html',
  styleUrls: ['./company-location-selector.component.css']
})
export class CompanyLocationSelectorComponent implements OnInit, AfterViewInit {



  companies = new Array<any>();

  selectedCompany;
  companyid: number = -1;

  selectedLocation;
  locationid: number = -1;
  
  valid: boolean = false;
  departments;
  selectedDepartment;
  departmentid;
  showLocations = true;



  @Output() locationSelected: EventEmitter<any> = new EventEmitter();
  @Output() onLoaded: EventEmitter<any> = new EventEmitter();
  @Output() companySelected: EventEmitter<any> = new EventEmitter();
  @Output() invalidCompanyCombination: EventEmitter<any> = new EventEmitter();
  @Input() options: CompanyLocationSelectorOptions;

  constructor(private companyService: CompanyService) {


  }

  ngOnInit() {
    this.onGetCompanies();
  }

  ngAfterViewInit(): void {
  }

  reset(){
    this.selectedCompany = null;
    this.selectedLocation = null;
    this.companyid = -1;
    this.locationid = -1;
  }

  onCompanySelected(id) {
    this.invalidCompanyCombination.emit({});
    this.companyid = id;
    this.locationid = -1;
    this.selectedLocation = null;
    this.valid = false;
    this.selectedCompany = this.companies.find(x => x.id == this.companyid);
    if (this.selectedCompany) {
      this.companySelected.emit({
        companyid: this.selectedCompany.id,
        name:this.selectedCompany.company_name
      });
    } else {
      this.companySelected.emit({
        companyid: -1
      });
    }

  }

  onLocationSelected(id) {
    this.invalidCompanyCombination.emit({});
    this.locationid = id;

    this.selectedLocation = this.selectedCompany.locations.find(x => x.id == id);
    if(this.selectedLocation){
      this.locationSelected.emit({
        companyid: this.selectedCompany.id,
        locationid: this.selectedLocation.id,
        address:this.selectedLocation.address,
        lat:this.selectedLocation.lat,
        lng:this.selectedLocation.lng
      });
    }else{
      this.locationSelected.emit({
        companyid: this.selectedCompany.id,
        locationid: -1
      });
    }
    this.valid = true;
    if (this.options.showDepartments && id != -1) {
      this.companyService.getDepartments(this.companyid, this.locationid).then((res: any) => {
        if (res.status) {
          this.departments = res.data;
        } else {
          alert("Unable to get departments for company location:" + res.message);
        }
      }).catch(e => {
        alert("Unable to get departments for company location:" + e);
      })
    }
    if(id == -1){
      this.valid = false;
    }


  }

  onGetCompanies() {

    this.companyService.getCompany().then((res: any) => {
      if (res.status) {
        this.companies = this.companies.concat(res.data);
        this.onLoaded.emit(this.companies);
      } else {
        alert("Could not get companies: " + res.message);
      }
    }).catch(e => {
      alert("Could not get companies: " + e);
    });
  }

  onDepartmentSelected(value) {
    this.departmentid = value;
    this.selectedDepartment = this.departments.find(d => d.id == this.departmentid);
    console.log(this.selectedDepartment);
    console.log(this.departmentid);
  }

}

export interface CompanyLocationSelectorOptions {
  style?: {}
  class?: string,
  showDepartments?: boolean
  showLocations?:boolean
}



// WEBPACK FOOTER //
// ./src/app/shared/company-location-selector/company-location-selector.component.ts